import { useRouterState } from "@tanstack/react-router";
import { useEffect } from "react";

export const ScrollManager = () => {
  const routerState = useRouterState();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [routerState.location.pathname]);

  return null;
};
